import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';


import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaCalendarAlt, FaPlus, FaImages, FaEye, FaEdit } from 'react-icons/fa';
import { getEvents, getImageUrl } from '../services/api';

const visibilityLabels = {
  public: 'PUBLIC',
  unlisted: 'NON LISTÉ',
  private: 'PRIVÉ'
};

const PhotographerDashboard = () => {

  console.log('PhotographerDashboard rendered'); // Debugging log
  
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState(location.state?.successMessage || '');

  useEffect(() => {
    fetchEvents();
  }, []);

  useEffect(() => {
    if (location.state?.successMessage) {
      setSuccessMessage(location.state.successMessage);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const fetchEvents = async () => {
    try {
      const response = await getEvents();
      setEvents(response.events);
    } catch (err) {
      setError(err.message || 'Impossible de charger les événements');
    } finally {
      setLoading(false);
    }
  };

  const getVisibilityBadge = (visibility) => {
    const colors = {
      public: '#4CAF50',
      unlisted: '#FF8C42',
      private: '#9C27B0'
    };
    
    return (
      <span style={{
        background: colors[visibility] || colors.public,
        color: 'white',
        padding: '0.3rem 0.8rem',
        borderRadius: '15px',
        fontSize: '0.8rem',
        fontWeight: '600',
        marginLeft: '0.5rem'
      }}>
        {visibilityLabels[visibility] || 'PUBLIC'}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '4rem' }}>
        <div className="spinner"></div>
        <p>Chargement de vos événements...</p>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="dashboard-header">
        <h1>Mes événements photo</h1>
        <p>Gérez vos événements et vos imports de photos</p>
      </div>

      {error && <div className="error-message">{error}</div>}
      {successMessage && <div className="success-message">{successMessage}</div>}

      <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Link to="/create-event" className="btn-primary">
          <FaPlus /> Créer un nouvel événement
        </Link>
        {user?.subscription_plan && (
          <div style={{
            padding: '0.8rem 1.5rem',
            background: 'var(--off-white)',
            borderRadius: '8px',
            fontSize: '0.9rem'
          }}>
            <strong>Forfait :</strong> {user.subscription_plan.charAt(0).toUpperCase() + user.subscription_plan.slice(1)} • 
            <strong> �v�nements :</strong> {events.length} / {user.event_limit === -1 ? '∞' : user.event_limit}
          </div>
        )}
      </div>

      {events.length === 0 ? (
        <div style={{ 
          padding: '3rem', 
          textAlign: 'center', 
          background: 'var(--white)', 
          borderRadius: '15px',
          boxShadow: '0 4px 8px var(--shadow)'
        }}>
          <FaCalendarAlt style={{ fontSize: '4rem', color: 'var(--gray)', marginBottom: '1rem' }} />
          <h3 style={{ color: 'var(--dark-gray)', marginBottom: '1rem' }}>
            Aucun événement pour le moment
          </h3>
          <p style={{ color: 'var(--gray)', marginBottom: '2rem' }}>
            Créez votre premier événement pour commencer à importer et organiser vos photos
          </p>
          <Link to="/create-event" className="btn-primary">
            Créer votre premier événement
          </Link>
        </div>
      ) : (
        <div className="events-list">
          {events.map((event) => (
            <div key={event.id} className="event-card">
              <div style={{
                height: '150px',
                margin: '-1.5rem -1.5rem 1rem',
                background: 'linear-gradient(135deg, var(--primary-orange), var(--primary-green))',
                overflow: 'hidden',
              }}>
                {event.cover_photo ? (
                  <img
                    src={getImageUrl(event.cover_photo)}
                alt={`Couverture de ${event.name}`}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                ) : (
                  <div style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'rgba(255,255,255,0.85)',
                    fontSize: '2.5rem',
                  }}>
                    <FaImages />
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '1rem' }}>
                <h3>{event.name}</h3>
                {getVisibilityBadge(event.visibility)}
              </div>
              <div style={{ marginTop: '0.5rem' }}>
                <span className="category-badge">{event.category}</span>
              </div>
              <p style={{ color: 'var(--gray)', marginTop: '1rem' }}>
                {event.description || 'Aucune description'}
              </p>
              <div style={{ 
                marginTop: '1rem', 
                paddingTop: '1rem', 
                borderTop: '1px solid var(--light-gray)',
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '0.9rem',
                color: 'var(--gray)'
              }}>
                <span>📸 {event.photo_count} photos</span>
                {event.event_date && (
                  <span>📅 {new Date(event.event_date).toLocaleDateString()}</span>
                )}
              </div>
              
              <div style={{ marginTop: '1rem', display: 'flex', gap: '0.45rem', flexWrap: 'wrap' }}>
                <Link
                  to={`/event/${event.id}/photos`}
                  style={{
                    flex: '1 1 120px',
                    minWidth: 0,
                    padding: '0.55rem 0.65rem',
                    background: 'var(--primary-orange)',
                    color: 'white',
                    textAlign: 'center',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    fontSize: '0.85rem',
                    lineHeight: 1.2,
                    whiteSpace: 'nowrap'
                  }}
                >
                  <FaImages /> Importer
                </Link>
                <Link
                  to={`/event/${event.id}/browse`}
                  style={{
                    flex: '1 1 110px',
                    minWidth: 0,
                    padding: '0.55rem 0.65rem',
                    background: 'var(--primary-green)',
                    color: 'white',
                    textAlign: 'center',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    fontSize: '0.85rem',
                    lineHeight: 1.2,
                    whiteSpace: 'nowrap'
                  }}
                >
                  <FaEye /> Parcourir
                </Link>
                <Link
                  to={`/event/${event.id}/edit`}
                  style={{
                    flex: '0 1 84px',
                    minWidth: '76px',
                    padding: '0.55rem 0.65rem',
                    background: '#7c3aed',
                    color: 'white',
                    textAlign: 'center',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    fontSize: '0.85rem',
                    lineHeight: 1.2,
                    whiteSpace: 'nowrap'
                  }}
                >
                  <FaEdit /> Modifier
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PhotographerDashboard;

